import { loadable } from 'jotai/utils';
import { Atom } from 'jotai';
import { tasksAtom, filteredTasksAtom } from '../atoms/v0/taskAtoms';
import { projectsAtom, projectTasksAtom } from '../atoms/v0/projectAtoms';

// 创建loadable包装的任务原子
export const loadableTasksAtom = loadable(tasksAtom);
export const loadableFilteredTasksAtom = loadable(filteredTasksAtom);

// 创建loadable包装的项目原子
export const loadableProjectsAtom = loadable(projectsAtom);
export const loadableProjectTasksAtom = loadable(projectTasksAtom);

// 创建一个通用的loadable包装函数
export function createLoadable<T>(atom: Atom<T>) {
  return loadable(atom);
}

// 全局Suspense解决方案
// 无论是哪个组件读取的原子状态，只要使用这些工具函数，就不会触发Suspense
export const preventSuspense = <T,>(data: T) => {
  if (data instanceof Promise) {
    // 对于Promise，返回一个默认值或空值，避免挂起
    return undefined as unknown as T;
  }
  return data;
};

// 安全地读取原子状态的工具函数
export function readAtomSafely<T>(getValue: () => T, defaultValue: T): T {
  try {
    const value = getValue();
    return preventSuspense(value) || defaultValue;
  } catch {
    return defaultValue;
  }
} 